Vendd.Scripts.load(function () {

    $('.x-photogallery.x-photogallery-carousel.document-gallery').each(function (i, wrapper) {
        if (!$(wrapper).data('init'))
            return;

        var $wrapper = $(this);
        //var $normalWrapper = $('> ul', $wrapper);

        var fbOpts = {
            protect: true,
            infobar: true
        };
       
        initSwiper($wrapper[0]);
        $('.fancylink', $wrapper).fancybox(fbOpts);
                  
    });

    function initSwiper(items) {

        const photoGallerySlider = new Swiper(items, {
            slidesPerView: 1,
            speed: 1000,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: { slidesPerView: "auto" }
            }
        });

    }
});